var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding":"40px"}},[_c('hi-tabs',[_c('hi-tab-panel',{attrs:{"title":"Caption History"}},[_c('div',[_vm._v("111")])]),_c('hi-tab-panel',{attrs:{"title":"Save Hashtags/Caption"}},[_c('div',[_vm._v("222")])]),_c('hi-tab-panel',{attrs:{"title":"标题3"}},[_c('div',[_vm._v("333")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }